// LoginTab.js

import { useState, useContext, useEffect, useRef } from "react";
import { Form, FormGroup, Input, Label } from "reactstrap";
import { Btn, P, Image } from "../../../AbstractElements";
import { ForgotPassword, Password, SignIn } from "../../../Constant";
import { useNavigate, Link } from "react-router-dom";
import { Eye, EyeOff } from "react-feather";
import "./LoginTab.css";
import { useDispatch, useSelector } from "react-redux";
import {
  login,
  setShowOtpScreenValue,
  setShowResetPwdScreenValue,
  setEmailValue,
  setPasswordValue,
} from "../../../store/slices/authNewSlice";
import CustomizerContext from "../../../_helper/Customizer";
import CubaIcon from "../../../assets/images/logo/logo.png";
import PropTypes from "prop-types";

const LoginTab = ({ selected }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const [localError, setLocalError] = useState("");

  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);

  const dispatch = useDispatch();
  const { loading, error, user } = useSelector((state) => state.auth);

  const inputRefs = useRef ([]);

  useEffect(() => {
    const resetPage = async () => {
      dispatch(setShowOtpScreenValue(false));
      dispatch(setShowResetPwdScreenValue(false));
      dispatch(setEmailValue(""));
      dispatch(setPasswordValue(""));
    };
    resetPage();
  }, [dispatch]);

  const loginAuth = async (e) => {
    e.preventDefault();
    setLocalError("");
    // Basic client-side validation
    if (!email) {
      setLocalError("Please enter your email.");
      return;
    }
    if (!password) {
      setLocalError("Please enter your password.");
      return;
    }
    try {
      const user = await dispatch(login({ email, password })).unwrap();
      dispatch(setEmailValue(email));
      dispatch(setPasswordValue(password));
      dispatch(setShowOtpScreenValue(true));
      history(`${process.env.PUBLIC_URL}/otp`);
    } catch (err) {
      const msg = err?.message || 'Access denied. Invalid login credentials';
      setLocalError(msg);
      console.error('Failed to login: ', err);
    }
  };

  return (
    <Form className="theme-form" onSubmit={loginAuth} aria-labelledby="login-heading">
      <div className="text-center">
        <Link to={`${process.env.PUBLIC_URL}/pages/sample-page/${layoutURL}`}>
          <Image
            attrImage={{
              className: "img-fluid d-inline",
              src: `${CubaIcon}`,
              alt: "Company logo",
            }}
          />
        </Link>
        <h5 id="login-heading" className="mt-3">Login</h5>
      </div>
      <FormGroup>
        <Label className="col-form-label">{"Username"}</Label>
        <Input
          className="form-control"
          type="email"
          name="email"
          placeholder="Enter your email address"
          aria-label="Email address"
          onChange={(e) => { setLocalError(""); setEmail(e.target.value); }}
          value={email}
          style={{ height: "80%" }}
          disabled={loading}
        />
      </FormGroup>
      <FormGroup className="position-relative">
        <Label className="col-form-label">{Password}</Label>
        <div className="position-relative">
          <Input
            className="form-control"
            type={togglePassword ? "text" : "password"}
            name="password"
            placeholder="Enter your password"
            aria-label="Password"
            onChange={(e) => { setLocalError(""); setPassword(e.target.value); }}
            value={password}
            style={{ paddingRight: "45px" }}
            disabled={loading}
          />
          <button
            type="button"
            className="show-hide"
            onClick={() => setTogglePassword(!togglePassword)}
            aria-label="Toggle password visibility"
          >
            {togglePassword ? (
              <Eye size={18} color="#7366ff" />
            ) : (
              <EyeOff size={18} color="#7366ff" />
            )}
          </button>
        </div>
      </FormGroup>
      <div aria-live="polite" aria-atomic="true">
        {(error || localError) && (
          <P style={{ color: 'red', textAlign: 'center', marginTop: 10 }}>
            {localError || error?.message || 'Access denied. Invalid login credentials'}
          </P>
        )}
      </div>
      <div className="position-relative form-group mb-0">
        <button
          type="button"
          className="link"
          onClick={(e) => {
            e.preventDefault();
            history(`${process.env.PUBLIC_URL}/reset-password`);
          }}
          style={{ order: 1 }}
        >
          {ForgotPassword}
        </button>
        <Btn
          attrBtn={{
            color: "danger",
            type: 'submit',
            style: { order: 2 },
            disabled: loading,
          }}
        >
          {loading ? "Signing In..." : SignIn}
        </Btn>
      </div>
    </Form>
  );
};

LoginTab.propTypes = {
  selected: PropTypes.any,
};

export default LoginTab;
